import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";

export const DEFAULT_BRAND = {
  brand_name: "DOOT",
  brand_tagline: "Fleet Live Tracking",
  brand_logo_url: null,
  brand_website: null,
  brand_support_email: null,
  brand_accent: "#00F0FF",
};

const BrandContext = createContext(DEFAULT_BRAND);

export const BrandProvider = ({ children }) => {
  const [brand, setBrand] = useState(DEFAULT_BRAND);

  useEffect(() => {
    axios
      .get(`${API}/public/branding`)
      .then(({ data }) => setBrand({ ...DEFAULT_BRAND, ...data }))
      .catch(() => {});
  }, []);

  useEffect(() => {
    document.title = `${brand.brand_name} - ${brand.brand_tagline}`;
  }, [brand]);

  return <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>;
};

export const useBrand = () => useContext(BrandContext);

export const BrandMark = ({ size = 20, className = "", showTagline = false, brand }) => {
  const b = brand || DEFAULT_BRAND;
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-mark">
      {b.brand_logo_url ? (
        <img
          src={b.brand_logo_url}
          alt={b.brand_name}
          data-testid="brand-logo"
          className="object-contain"
          style={{ height: size + 8, maxWidth: 140 }}
        />
      ) : (
        <span
          className="inline-flex items-center justify-center border font-head font-black"
          data-testid="brand-monogram"
          style={{
            width: size + 8,
            height: size + 8,
            borderColor: b.brand_accent,
            color: b.brand_accent,
            fontSize: size * 0.6,
          }}
        >
          {b.brand_name.trim().charAt(0).toUpperCase()}
        </span>
      )}
      <span className="font-head font-black tracking-tight" style={{ fontSize: size }} data-testid="brand-name">
        {b.brand_name}
      </span>
      {showTagline && <span className="overline mt-1">{b.brand_tagline}</span>}
    </div>
  );
};
